import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { FontFamilies } from "@/constants/Typography";
import { StripeInvoice } from "@/services/stripePaymentServices";
import InvoiceCard from "./InvoiceCard";

interface InvoiceHistorySectionProps {
  invoices: StripeInvoice[];
}

const InvoiceHistorySection: React.FC<InvoiceHistorySectionProps> = ({
  invoices,
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Invoice history</Text>

      {invoices.length === 0 ? (
        <View style={styles.emptyCard}>
          <Text style={styles.emptyText}>No invoices yet</Text>
        </View>
      ) : (
        invoices.map((invoice) => (
          <InvoiceCard key={invoice.id} invoice={invoice} />
        ))
      )}
    </View>
  );
};

export default InvoiceHistorySection;

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
  },
  title: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Medium,
    color: "#161D14",
    marginBottom: 8,
  },
  emptyCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
    alignItems: "center",
  },
  emptyText: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(22, 29, 20, 0.5)",
  },
});
